import { tickerItems } from '@/mocks/homeData';

export default function TickerBar() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <section id="ticker" className="relative w-full border-y border-primary-950/20 bg-primary-500">
      <div className="flex w-full items-stretch">
        <div className="flex shrink-0 items-center gap-2 bg-primary-950 px-4 py-4 md:px-8">
          <span className="flex h-5 w-5 items-center justify-center">
            <i className="ri-flashlight-line text-accent-300" />
          </span>
          <span className="whitespace-nowrap font-heading text-sm font-semibold tracking-wide text-background-50 md:text-base">
            新料速递
          </span>
        </div>

        <div className="marquee-wrap relative flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center gap-8 py-4 pl-6">
            {loopItems.map((item, index) => (
              <span key={`${item.id}-${index}`} className="flex items-center gap-3 whitespace-nowrap">
                <span className="font-label text-xs text-primary-100 md:text-sm">{item.time}</span>
                <span className="rounded-full bg-primary-950/30 px-2.5 py-1 text-[11px] text-background-100 md:text-xs">
                  {item.tag}
                </span>
                <span className="text-sm text-background-50 md:text-base">{item.text}</span>
                <span className="text-accent-200">·</span>
              </span>
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-primary-500 to-transparent md:w-24" />
        </div>
      </div>

      <div className="border-t border-primary-950/20 px-4 py-3 md:px-8">
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-primary-100 md:text-sm">
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line" />
            按进入顺序排列，最新的在左侧
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-refresh-line" />
            热点集中时段可能连更数条
          </span>
          <span className="hidden items-center gap-1.5 sm:flex">
            <i className="ri-link" />
            每条都可对照现场爆料分区
          </span>
        </div>
      </div>
    </section>
  );
}